import React from "react";

const ModeratorMenuView = ({ generateMessages, downloadCSV, showOnlyHighlighted, filter, type, corporateSettings, downloadCorporateAllChatCSV }) => {
    const isCorporate = () => {
        return type === "corporate"
    }
    const SHOW_GENERATE_MESSAGES = false

    return <div className="btn-group dropup caret-off moderator-menu-wrapper">
        <button type="button" className="btn p-0 moderator-menu-button focus-outline-purple" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img
                src='/assets/moderatormenugray.svg'
                alt=''
                width="25"
                height="4"
            />
        </button>

        {!isCorporate() &&

            <div className="dropdown-menu custom-dropdown">
                <button type="button" onClick={downloadCSV} className="dropdown-item" >
                    <u>Export chat as CSV</u>
                </button>
                <button type="button" onClick={showOnlyHighlighted} className="dropdown-item">
                    <u>{!filter ? "Show only starred" : "Show all messages"}</u>
                </button>
                {SHOW_GENERATE_MESSAGES && (
                    <button type="button" onClick={() => generateMessages(500)} className="dropdown-item">
                        <u>Generate messages</u>
                    </button>
                )}
            </div>
        }

        {corporateSettings &&

            <div className="dropdown-menu corporate-dropdown custom-dropdown">
                <button type="button" onClick={downloadCorporateAllChatCSV} className="dropdown-item" >
                    <u>Exports all chats</u>
                </button>

            </div>
        }
        {isCorporate() &&

            <div className="dropdown-menu corporate-dropdown custom-dropdown">
                <button type="button" className="dropdown-item" >
                    <u>Trash/Restore</u>
                </button>
                <button type="button" onClick={showOnlyHighlighted} className="dropdown-item">
                    <u>Export chat as CSV</u>
                </button>
                {SHOW_GENERATE_MESSAGES && (
                    <button type="button" onClick={() => generateMessages(500)} className="dropdown-item">
                        <u>Generate messages</u>
                    </button>
                )}
            </div>
        }






    </div>
}
export default ModeratorMenuView;